import { CloseOutlined } from "@ant-design/icons";
import { Col, Tooltip } from "antd";
import { useState } from "react";
import { RiDeleteBin6Line } from "react-icons/ri";

import ImageMarker, { Marker, MarkerComponentProps } from "react-image-marker";

import "./styles/index.less";

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  src?: string;
  value?: Marker[] | [];
  type?: string;
  onChange?: (e: any) => void;
}

interface CustomMarkerProps extends React.HTMLAttributes<HTMLDivElement> {
  markers: Marker[] | [];
  value: MarkerComponentProps;
  onChange?: (e: any) => void;
}
const CustomMarker = (props: CustomMarkerProps) => {
  const [isHovered, setIsHovered] = useState<boolean>(false);
  const toggleHover = () => {
    setIsHovered(!isHovered);
  };

  const onRemove = () => {
    const values = [...props.markers].slice(0, (props.value.uid || 1) - 1);
    props.onChange && props.onChange(values);
  };
  return (
    <Tooltip
      title={
        <span>
          <CloseOutlined />
          <span style={{ fontSize: "0.9em" }}>
            Delete Marker {Number(props.value.uid)}
          </span>
        </span>
      }
      placement="bottom"
    >
      <div
        className="hotspot "
        onClick={onRemove}
        onMouseEnter={toggleHover}
        onMouseLeave={toggleHover}
      >
        <div className="button-wrap">
          <button className="pulse-button">
            {isHovered ? (
              <span style={{ fontSize: "1rem" }}>
                <RiDeleteBin6Line />
              </span>
            ) : (
              <div>{props.value.uid}</div>
            )}
          </button>
        </div>
      </div>
    </Tooltip>
  );
};

const MarkerImage = ({ type = "abus", ...props }: Props) => {
  const handleOnChange = (newMarkers: Marker[]) => {
    props.onChange && props.onChange(newMarkers);
  };

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyItems: "center",
          justifyContent: "space-between",
          paddingTop: "10px",
          paddingLeft: "30px",
          paddingRight: "30px",
        }}
      >
        <Col span={12} style={{ textAlign: "center" }}>
          R
        </Col>
        <Col span={12} style={{ textAlign: "center" }}>
          L
        </Col>
      </div>
      <ImageMarker
        src={props.src || ""}
        markers={
          props.value
            ?.map((item, index) => {
              return { ...item, uid: index + 1 };
            })
            ?.filter((item) => item.type === type) || []
        }
        markerComponent={(data) => (
          <CustomMarker
            value={data}
            markers={props?.value || []}
            onChange={props.onChange}
          />
        )}
        onAddMarker={(marker) =>
          handleOnChange([...(props?.value || []), { ...marker, type: type! }])
        }
      />
    </div>
  );
};

export default MarkerImage;
